<template>
  <div>
    <b-loading :active.sync="loadingInicial" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title
        v-if="lista_setor"
        :text="
          'Atividades Setor: ' + $route.params.setor + ' - ' +
          lista_setor.find((item) => item.id === sub_setor)?.label
        "
      />


      <v-btn
        color="#031127"
        style="border-radius: 25px"
        dark
        small
        @click.native="listar_atividades_competencia"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>

    <v-row class="gap-1 mb-4 justify-end">
    <v-btn
        color="primary"
        small
        @click="showModalCompetencia()"
      >
        Cadastrar
      </v-btn>
      <v-btn
        color="info"
        small
        @click="TabelaTipoAtividade()"
      >
       Tabela tipos atividade
      </v-btn>
    </v-row>
   

    <div class="w-full flex justify-start gap-2 mb-2">
      <div class="w-2/6">
        <Lynx-Label label="Data de competência" />
        <b-datepicker
          type="month"
          placeholder="Selecione a data de competência"
          icon="calendar-today"
          :month-names="monthNames"
          v-model="filtros.competencia"
        />
      </div>
      <div class="w-1/5">
        <Lynx-Label label="Tipo" />
        <treeselect
          :multiple="false"
          :options="lista_tipo"
          placeholder="Selecione o tipo..."
          v-model="filtros.tipo"
        />
      </div>

      <div class="w-1/5">
        <Lynx-Label label="Sub setor" />
        <treeselect
          :multiple="false"
          :options="lista_setor"
          placeholder="Selecione o setor..."
          v-model="sub_setor"
        />
      </div>

      <div class="w-2/6">
        <Lynx-Label label="Selecione tipo atividade" />
        <treeselect
          :multiple="false"
          :options="lista_tipos_atividade"
          placeholder="Selecione tipo da atividade..."
          v-model="filtros.tipo_atividade_id"
        />
      </div>
    </div>
    <div v-if="pagination">
      <b-table
        :loading="loading"
        backend-pagination
        @page-change="onPageChange"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        :columns="columns"
        :data="loading ? [] : lista_atividades_competencia"
        :total="pagination.total"
        :current-page="pagination.current_page"
        :per-page="pagination.per_page"
        paginated
        striped
      >
        <template slot-scope="props" v-if="props.row.id != null">
          <b-table-column field="nome">
            {{
              props.row.tipo_atividade
                ? props.row.tipo_atividade.nome.toUpperCase()
                : ""
            }}

            {{ monthNames[parseInt(props.row.competencia.split("-")[1]) - 1] }}
          </b-table-column>

          <b-table-column field="competencia">
            {{ props.row.competencia | formatEnToBr }}
          </b-table-column>

          <b-table-column field="created_at">
            {{ props.row.created_at | formatEnToBr }}
          </b-table-column>

          <b-table-column field="acoes">
            <Lynx-Button
              class=""
              icon-size="7"
              icon="ArrowRight"
              size="small"
              @click.native="enterCompetencia(props.row)"
            />
            <Lynx-Button
              v-if="hasRole('super-admin')"
              color="error-base"
              icon-size="7"
              icon="Trash"
              size="small"
              @click.native="confirmDelete(props.row)"
            />
          </b-table-column>
        </template>
        <template v-slot:empty>
          <NotFoundData text="Nenhum convite encontrado!" />
        </template>
      </b-table>
    </div>
    <b-modal :active.sync="modalCompetencia" :width="500">
      <div class="bg-white p-5" style="height: 360px">
        <Lynx-Title text="Competência da Planilha" />
        <div class="flex w-full space-x-4">
          <div class="flex flex-col w-1/2">
            <Lynx-Label label="Data de competência" />
            <b-datepicker
              type="month"
              placeholder="Selecione a data de competência"
              icon="calendar-today"
              :month-names="monthNames"
              v-model="form.dataCompetencia"
            />
          </div>
          <div class="flex flex-col w-1/2">
            <Lynx-Label label="Selecione tipo atividade" />
            <treeselect
              :multiple="false"
              :options="lista_tipos_atividade"
              placeholder="Selecione tipo da atividade..."
              v-model="form.tipo_atividade_id"
            />
          </div>
        </div>
      </div>
      <footer class="modal-card-foot flex justify-between">
        <b-button
          @click.native="hideModalCompetencia()"
          type="is-danger"
          class="mt-4"
          >Cancelar</b-button
        >
        <b-button
          @click.native="createCompTeb()"
          type="is-primary"
          class="ml-4 mt-4"
          >Salvar</b-button
        >
      </footer>
    </b-modal>
  </div>
</template>
  
  <script>
import NotFoundData from "@/components/layouts/NotFoundData";
import { formatEnToBr } from "@/utils/momentHelpers";

import { monthNames } from "@/utils/utils";
import moment from "moment";
import { hasRole } from "@/utils/can";
import { mapGetters } from "vuex";
import Treeselect from "@riophae/vue-treeselect";
import {
  TiposEnum,
  ContabilidadeSubSetoresEnum,
  LegalizacaoSubSetoresEnum,
  CsSubSetoresEnum,
} from "@/utils/enum";

export default {
  components: { NotFoundData, Treeselect },
  data() {
    return {
      monthNames,
      form: { dataCompetencia: new Date(), tipo: null },
      columns: [
        {
          field: "nome",
          label: "ID",
          sortable: true,
        },

        {
          field: "competencia",
          label: "Competencia",
        },
        {
          field: "created_at",
          label: "criação",
        },

        {
          field: "acoes",
          label: "Ações",
        },
      ],
      modalCompetencia: false,
      selectedFiles: [],
      loading: false,
      loadingInicial: false,
      pasta_selected: null,
      isPressing: false,
      timer: null,
      preciona: 0,
      editavel: 0,
      filtros: {
        page: 1,
        perPage: 10,
        tipo: null,
        sub_setor: null,
        tipo_atividade_id: null,
        competencia: null,
        setor: this.$route.params.setor,
      },
      sub_setor: "todos",
      perPageOptions: [10, 50, 100],
      current_page: 1,
      lista_setor: [],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),

    atividades_competencia() {
      return this.$store.state.atividadesCompetencia
        .lista_atividades_competencia;
    },

    lista_atividades_competencia() {
      return this.atividades_competencia.data;
    },

    pagination() {
      return this.atividades_competencia.pagination;
    },
    mensagem_alert() {
      return this.$store.state.atividadesCompetencia.mensagem_alert;
    },
    lista_tipos_atividade() {
      return this.$store.state.tipoAtividade.lista_tipos_atividade_todos.map(
        (tipo) => {
          return {
            id: tipo.id,
            label: tipo.nome,
          };
        }
      );
    },

    lista_tipo() {
      return TiposEnum;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.listar_atividades_competencia();
    },
    sub_setor: function (value) {
      this.listar_atividades_competencia();
    },
    current_page() {
      this.listar_atividades_competencia();
    },
    '$route.params.setor': function (value) {
      this.filtros.setor = value;
      this.listar_tipos_atividade();
      this.listar_inicial();
    },
  },
  created() {
    this.listar_inicial();
  },
  mounted() {
    this.listar_tipos_atividade();
  },
  filters: {
    formatEnToBr,
  },
  methods: {
    hasRole,
    async listar_inicial() {
      const setorParaFiltro = {
        contabilidade: ContabilidadeSubSetoresEnum,
        legalizacaoOnboarding: LegalizacaoSubSetoresEnum,
        cs: CsSubSetoresEnum,
      };

      // Verificar se algum dos sub-setores corresponde ao valor
      this.lista_setor = [
        { id: "todos", label: "Todos" },
        ...setorParaFiltro[this.$route.params.setor],
      ];


      this.sub_setor = "todos";
      this.loadingInicial = true;
      await this.listar_atividades_competencia();
      this.loadingInicial = false;
    },
    enterCompetencia(atividade_competencia) {
      // if (
      //   !this.hasRole("super-admin") &&
      //   moment(atividade_competencia.competencia).format("YYYY-MM-01") !=
      //     moment(new Date()).subtract(1, "months").format("YYYY-MM-01")
      // ) {
      //   this.$snack.error("Apenas competencia atual");
      // } else {
      this.$router.push({
        name: "dctfweb.index",
        params: { atividade_competencia_id: atividade_competencia.id },
      });
      // }
    },
    hideModalCompetencia() {
      this.modalCompetencia = false;
    },

    showModalCompetencia() {
      this.modalCompetencia = true;
    },
    async createCompTeb() {
      this.loading = true;

      await this.$store
        .dispatch(
          "atividadesCompetencia/create_atividades_competencia",
          this.form
        )
        .then(() => {
          if (this.mensagem_alert.tipo == "success") {
            this.$snack.success(this.mensagem_alert.message);
          } else {
            this.$snack.error(this.mensagem_alert.message);
          }
          this.listar_atividades_competencia();
        })
        .catch((err) => {
          this.$snack.error("erro " + err);
        })
        .finally(() => {
          this.hideModalCompetencia();
          this.loading = false;
        });
    },
    async listar_atividades_competencia() {
      this.loading = true;

      if (this.sub_setor == "todos") {
        this.filtros.sub_setor = null;
      } else {
        this.filtros.sub_setor = this.sub_setor;
      }
      const { filtros } = this;
      await this.$store.dispatch(
        "atividadesCompetencia/listar_atividades_competencia",
        filtros
      );
      this.loading = false;
    },
    async listar_tipos_atividade() {
      await this.$store.dispatch("tipoAtividade/listar_tipos_atividade_todas", {
        setor: this.filtros.setor,
      });
    },
    TabelaTipoAtividade() {
      this.$router.push({
        name: "tipos-atividade.index",
        params: { setor: this.$route.params.setor },
      });
    },
    onPageChange(page) {
      this.current_page = page;
    },

    async confirmDelete(atividade_competencia) {
      await this.$buefy.dialog.confirm({
        message: "Esta ação deleta uma atividade no sistema?",
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          this.delete(atividade_competencia);
        },
      });
    },

    async delete(atividade_competencia) {
      await this.$store
        .dispatch(
          "atividadesCompetencia/delete_atividades_competencia",
          atividade_competencia
        )
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
        })
        .catch((error) => this.$snack.error(this.mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
</style>
  